import {useImportContext} from "./ImportContextProvider";
import {useCallback, useMemo, useState} from "react";
import {AxiosResponse, isAxiosError} from "axios";
import {Import} from "./types";
import {apiV2} from "../../../api/axiosConfig";
import {ImportRow} from "./useImportParser";
import {useChunkedArray} from "./useChunkedArray";
import {useIncrement} from "./useIncrement";



export const useSubmitImport = (sendInvitationEmails: boolean, name: string, flags: string[]) => {

    const [chunkSize] = useState(200)
    const {headers, rows, clientID, gotoStage, clear} = useImportContext();

    const rowChunks = useChunkedArray(rows, chunkSize)

    const [submitting, setSubmitting] = useState<boolean>(false);

    const [error, setError] = useState<string | null>(null)

    const [progress, incrementProgress, resetProgress] = useIncrement()

    const rowCount = useMemo(() => {
        return rows.length;
    }, [rows])

    const chunkCount = useMemo(() => {
        return Math.ceil(rowCount / chunkSize)
    }, [rowCount, chunkSize])

    const submitRow = useCallback(async (uploadID: string, rows: ImportRow[], index: number) => {
        await apiV2.post(`import/${uploadID}`, {
            index: index + 1,
            data: rows,
        })

        incrementProgress(rows.length)
    }, [])

    const handleSubmitSuccess = useCallback(async (res: AxiosResponse<Import>) => {
        for (const [index, chunk] of rowChunks.entries()) {
            await submitRow(res.data.id, chunk, index)
        }
        clear()
        gotoStage("select_file")


    }, [rowChunks, clear])

    const handleSubmitError = useCallback((error: Error) => {
        if (isAxiosError(error)) {
            if (error?.response?.data?.error) {
                setError(error?.response?.data?.error)
                return
            }
        }
        setError("an error occurred")
    }, [])

    const submit = useCallback(() => {
        setSubmitting(true)
        resetProgress()

        console.log(flags)

        const req = {
            clientID,
            headers,
            rowCount,
            chunkCount,
            flags,
            type : "user",
            name
        }

        apiV2.post<Import>("import", req)
            .then(handleSubmitSuccess)
            .catch(handleSubmitError)
            .finally(() => setSubmitting(false))

    }, [handleSubmitSuccess,
        handleSubmitError,
        clientID,
        rowCount,
        chunkCount,
        headers,
        sendInvitationEmails,
        flags,
    ])

    return {error, submit, submitting, progress}

}